import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';
import {
  GatewayLoginRequest,
  GatewayLoginResponse,
} from 'src/app/services/auth/gateway-auth.types';

/**
 * API Gateway: autenticación (JWT).
 * Legacy: GET `login_qa.aspx` / `login_v2.aspx` con headers User, Pass (y RutEmp).
 * Gateway: POST `/login` relativo a la base transportista.
 */
@Injectable({ providedIn: 'root' })
export class TransportistaLoginGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  login(
    body: GatewayLoginRequest,
    options?: TransportistaGatewayPostOptions
  ): Observable<GatewayLoginResponse> {
    const payload: Record<string, string> = {
      user: body.user,
      pass: body.pass,
    };
    if (body.rutEmp) {
      payload.rutEmp = body.rutEmp;
    }
    return this.gw.post<GatewayLoginResponse>('/login', payload, options);
  }
}
